import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

const SERVICE_TYPES = [
  { id: 'tree_removal', name: 'Tree Removal', category: 'Tree Services', description: 'Complete removal of trees' },
  { id: 'tree_trimming', name: 'Tree Trimming & Pruning', category: 'Tree Services', description: 'Maintenance trimming and shaping' },
  { id: 'stump_grinding', name: 'Stump Grinding', category: 'Tree Services', description: 'Removal of tree stumps' },
  { id: 'emergency_services', name: 'Emergency Tree Services', category: 'Tree Services', description: 'Storm damage, fallen trees' },
  { id: 'lot_clearing', name: 'Lot Clearing', category: 'Land Services', description: 'Clearing land for development' },
  { id: 'brush_clearing', name: 'Brush Clearing', category: 'Land Services', description: 'Removal of brush and undergrowth' },
  { id: 'debris_hauling', name: 'Debris Hauling', category: 'Hauling Services', description: 'Removal and disposal of debris' },
  { id: 'wood_chipping', name: 'Wood Chipping', category: 'Hauling Services', description: 'Chipping and removal of wood' },
  { id: 'right_of_way', name: 'Right-of-Way Clearing', category: 'Specialized Services', description: 'Utility and road clearance' },
  { id: 'vegetation_management', name: 'Vegetation Management', category: 'Specialized Services', description: 'Ongoing vegetation control' },
];

const SIZE_OPTIONS = [
  { value: 'small', label: 'Small (Under $1,000)' },
  { value: 'medium', label: 'Medium ($1,000-$10,000)' },
  { value: 'large', label: 'Large ($10,000-$50,000)' },
  { value: 'enterprise', label: 'Enterprise (Over $50,000)' },
];

const HOW_HEARD_OPTIONS = [
  'Search Engine',
  'Social Media',
  'Referral',
  'Industry Event',
  'Advertisement',
  'Other',
];

function ServicesProvidedStep({ data, errors, onChange }) {
  const servicesProvided = data.services_provided || {};

  const handleServiceToggle = (serviceId) => {
    const current = servicesProvided[serviceId] || { needed: false };
    onChange({
      services_provided: {
        ...servicesProvided,
        [serviceId]: { ...current, needed: !current.needed },
      },
    });
  };

  const handleGeneralChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const groupedServices = SERVICE_TYPES.reduce((acc, service) => {
    if (!acc[service.category]) acc[service.category] = [];
    acc[service.category].push(service);
    return acc;
  }, {});

  return (
    <div className="services-provided-step">
      <h5 className="mb-3">Services Provided</h5>
      <p className="text-muted mb-4">
        Select the services your company offers.
      </p>

      {errors.services_provided && (
        <Alert variant="danger">{errors.services_provided}</Alert>
      )}

      {Object.entries(groupedServices).map(([category, services]) => (
        <div key={category} className="mb-4">
          <h6 className="text-secondary mb-3">{category}</h6>
          {services.map((service) => {
            const svc = servicesProvided[service.id] || { needed: false };
            return (
              <div key={service.id} className={`service-item ${svc.needed ? 'selected' : ''}`}>
                <div className="service-header">
                  <div>
                    <Form.Check
                      type="checkbox"
                      id={`service-${service.id}`}
                      label={service.name}
                      checked={svc.needed}
                      onChange={() => handleServiceToggle(service.id)}
                    />
                    <small className="text-muted ms-4">{service.description}</small>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}

      <hr className="my-4" />

      <h6 className="mb-3">Project Information</h6>
      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group controlId="typical_project_size">
            <Form.Label>Typical Project Size</Form.Label>
            <Form.Select
              name="typical_project_size"
              value={data.typical_project_size}
              onChange={handleGeneralChange}
            >
              <option value="">Select size</option>
              {SIZE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <hr className="my-4" />

      <h6 className="mb-3">Additional Information</h6>
      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group controlId="how_heard_about_us">
            <Form.Label>How did you hear about us?</Form.Label>
            <Form.Select
              name="how_heard_about_us"
              value={data.how_heard_about_us}
              onChange={handleGeneralChange}
            >
              <option value="">Select option</option>
              {HOW_HEARD_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-3" controlId="additional_notes">
        <Form.Label>Additional Notes</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="additional_notes"
          value={data.additional_notes}
          onChange={handleGeneralChange}
          placeholder="Any other information you'd like to share about your service needs..."
        />
      </Form.Group>
    </div>
  );
}

export default ServicesProvidedStep;
